import Constant from "./Constant";
import CommonUtil from "../common/CommonUtil";
import stores from "../store";


export default {
  getUsualAddress: () => {
    let val = localStorage.getItem("USUAL_ADDRESS");
    if (val) {
      return JSON.parse(val);
    } else {
      return null;
    }
  },
  saveUsualAddress: (value) => {
    localStorage.setItem("USUAL_ADDRESS", JSON.stringify(value));
  },
  removeUsualAddress: () => {
    localStorage.removeItem("USUAL_ADDRESS");
  },
  getShowAgentTip: () => {
    let val = localStorage.getItem("SHOW_AGENT_TIP") || true;
    return val
  },
  saveShowAgentTip: (value) => {
    localStorage.setItem("SHOW_AGENT_TIP", value);
  },
  removeIsShare: () => {
    localStorage.removeItem("IS_SHARE");
  },
  getOpenScene: () => {
    let val = localStorage.getItem("OPEN_SCENE") || true;
    return val
  },
  saveOpenScene: (value) => {
    localStorage.setItem("OPEN_SCENE", value);
  },
  removeOpenScene: () => {
    localStorage.removeItem("OPEN_SCENE");
  },

  getIsShare: () => {
    let val = localStorage.getItem("IS_SHARE") || false;
    return val
  },
  saveIsShare: (value) => {
    localStorage.setItem("IS_SHARE", value);
  },
  removeShowLive: () => {
    localStorage.removeItem("SHOW_LIVE");
  },
  getShowLive: () => {
    let val = localStorage.getItem("SHOW_LIVE") || false;
    return val
  },
  saveShowLive: (value) => {
    localStorage.setItem("SHOW_LIVE", value);
  },
  removeShowHeadCompanyGuid: () => {
    localStorage.removeItem("SHOW_HEAD_COMPANY_GUID");
  },
  getShowHeadCompanyGuid: () => {
    let val = localStorage.getItem("SHOW_HEAD_COMPANY_GUID") || Constant.companyGuid;
    return val
  },
  saveShowHeadCompanyGuid: (value) => {
    localStorage.setItem("SHOW_HEAD_COMPANY_GUID", value);
  },
  removeShowCompanyGuid: () => {
    localStorage.removeItem("SHOW_COMPANY_GUID");
  },
  saveTopHouseGuid: (value) => {
    localStorage.setItem("TOP_HOUSE_GUID", value);
  },
  getTopHouseGuid: (value) => {
    let val = localStorage.getItem("TOP_HOUSE_GUID") || '';
    return val
  },
  removeTopHouseGuid: () => {
    localStorage.removeItem("TOP_HOUSE_GUID");
  },
  saveIsWeChart: (value) => {
    localStorage.setItem("IS_WECHART", value);
  },
  getIsWeChart: (value) => {
    let val = localStorage.getItem("IS_WECHART") || '';
    return val
  },
  removeIsWeChart: () => {
    localStorage.removeItem("IS_WECHART");
  },
  removeShareAgentGuid: () => {
    localStorage.removeItem("SHARE_AGENT_GUID");
  },
  getShareAgentGuid: () => {
    let val = localStorage.getItem("SHARE_AGENT_GUID") || '';
    return val
  },
  saveShareAgentGuid: (value) => {
    localStorage.setItem("SHARE_AGENT_GUID", value);
  },
  getShowCompanyGuid: () => {
    let val = localStorage.getItem("SHOW_COMPANY_GUID") || Constant.companyGuid;
    return val
  },
  saveShowCompanyGuid: (value) => {
    localStorage.setItem("SHOW_COMPANY_GUID", value);
  },
  saveUseLive: (value) => {
    localStorage.setItem("USE_LIVE", value);
  },
  getUseLive: () => {
    let val = localStorage.getItem("USE_LIVE");
    return val
  },
  saveGetNameDate: (value) => {
    localStorage.setItem("GET_NAME_DATE", value);
  },
  getGetNameDate: () => {
    let val = localStorage.getItem("GET_NAME_DATE");
    return val
  },
  saveFreeDesign: (value) => {
    localStorage.setItem("FREE_DESIGN", value);
  },
  getFreeDesign: () => {
    let val = localStorage.getItem("FREE_DESIGN");
    return val
  },
  saveShowWelfareTip: (value) => {
    localStorage.setItem("SHOW_WELFARE_TIP", value);
  },
  getShowWelfareTip: () => {
    let val = localStorage.getItem("SHOW_WELFARE_TIP");
    return val
  },
  saveWelfareSwitch: (value) => {
    localStorage.setItem("WELFARE_SWITCH", value);
  },
  getWelfareSwitch: () => {
    let val = localStorage.getItem("WELFARE_SWITCH");
    return val
  },
  saveOnlineHouseOrderSwitch: (value) => {
    localStorage.setItem("ONLINE_HOUSE_ORDER_SWITCH", value);
  },
  getOnlineHouseOrderSwitch: () => {
    let val = localStorage.getItem("ONLINE_HOUSE_ORDER_SWITCH");
    return val
  },
  saveRentHouseFreeSwitch: (value) => {
    localStorage.setItem("RENT_HOUSE_FREE_SWITCH", value);
  },
  getRentHouseFreeSwitch: () => {
    let val = localStorage.getItem("RENT_HOUSE_FREE_SWITCH");
    return val
  },
  saveUnitedSell: (value) => {
    localStorage.setItem("UNITED_SELL", value);
  },
  getUnitedSell: () => {
    let val = localStorage.getItem("UNITED_SELL");
    return val
  },
  saveGoodRoomSwitch: (value) => {
    localStorage.setItem("GOOD_ROOM_SWITCH", value);
  },
  getGoodRoomSwitch: () => {
    let val = localStorage.getItem("GOOD_ROOM_SWITCH");
    return val
  },
  removeFrienfsBl: () => {
    localStorage.removeItem("GET_FRIENFS_BL");
  },
  getFrienfsBl: () => {
    let val = localStorage.getItem("GET_FRIENFS_BL");
    return val
  },
  saveFrienfsBl: (value) => {
    localStorage.setItem("GET_FRIENFS_BL", value);
  },
  removeConfigCitys: () => {
    localStorage.removeItem("CONFIG_CITYS");
  },
  getConfigCitys: value => {
    let val = localStorage.getItem("CONFIG_CITYS");
    if (val) {
      return JSON.parse(val);
    } else {
      return null;
    }
  },
  saveConfigCitys: value => {
    localStorage.setItem("CONFIG_CITYS", JSON.stringify(value));
  },
  getMiniLogo: () => {
    let val = localStorage.getItem("CONFIG_LOGO");
    if (val) {
      return JSON.parse(val);
    } else {
      return null;
    }
  },
  saveMiniLogo: value => {
    let val = localStorage.setItem("CONFIG_LOGO", value);
    if (val) {
      return JSON.parse(val);
    } else {
      return null;
    }
  },
  saveHideChangeCity: value => {
    localStorage.setItem("HIDE_CHANGE_CITY", value);
  },
  getHideChangeCity: () => {
    let val = localStorage.getItem("HIDE_CHANGE_CITY");
    return val;
  },
  removeHideChangeCity: () => {
    localStorage.removeItem("HIDE_CHANGE_CITY");
  },

  setVoiceMsgData: value => {
    localStorage.setItem("TO_WECHAT_TIEM", value);
  },
  getVoiceMsgData: () => {
    let val = localStorage.getItem("TO_WECHAT_TIEM");

    return val;

  },
  removeVoiceMsgData: () => {
    localStorage.removeItem("TO_WECHAT_TIEM");
  },
  setItem: value => {
    localStorage.setItem("CHOOSELISTDATA", JSON.stringify(value));
  },
  getItem: () => {
    let val = localStorage.getItem("CHOOSELISTDATA");
    if (val) {
      return JSON.parse(val);
    } else {
      return null;
    }
  },
  removeItem: () => {
    localStorage.removeItem("CHOOSELISTDATA");
  },
  saveSessionKey: data => {
    localStorage.setItem("sessionKey", data);
  },
  getSessionKey: () => {
    return localStorage.getItem("sessionKey");
  },
  removeSessionKey: () => {
    localStorage.removeItem("sessionKey");
  },


  saveHouseTypeData: data => {
    localStorage.setItem("houseTypeData", JSON.stringify(data));
  },
  getHouseTypeData: () => {
    let val = localStorage.getItem("houseTypeData");
    if (val) {
      return JSON.parse(val);
    } else {
      return null;
    }
  },
  removeHouseTypeData: () => {
    localStorage.removeItem("houseTypeData");
  },
  saveAccessToken: token => {
    localStorage.setItem(Constant.ACCESSTOKEN, token);
  },
  getAccessToken: () => {
    return localStorage.getItem(Constant.ACCESSTOKEN);
  },
  removeAccessToken: () => {
    localStorage.removeItem(Constant.ACCESSTOKEN);
  },

  // saveUserInfo: (userInfo) => {
  //   localStorage.setItem(Constant.USERINFO, JSON.stringify(userInfo))
  // },
  // getUserInfo: () => {
  //   let val = localStorage.getItem(Constant.USERINFO)
  //   if (val) {
  //     return JSON.parse(val)
  //   }
  //   return null;

  // },
  // removeUserInfo: () => {
  //   localStorage.removeItem(Constant.USERINFO)
  // },
  /**
   * coustomer信息
   */
  saveCustomerInfo: customerInfo => {
    stores.nimStore.currentUserInfo = customerInfo
    localStorage.setItem(Constant.CUSTOMER, JSON.stringify(customerInfo));
  },
  getCustomerInfo: () => {
    let val = localStorage.getItem(Constant.CUSTOMER);
    if (val) {
      return JSON.parse(val);
    }
    return {};
  },
  removeCustomerInfo: () => {
    localStorage.removeItem(Constant.CUSTOMER);
  },
  saveLoginErrTipTime: time => {
    localStorage.setItem('LOGIN_ERR_TIP_TIME', time);
  },
  getLoginErrTipTime: () => {
    let val = localStorage.getItem('LOGIN_ERR_TIP_TIME');
    if (val) {
      return val;
    }
    return null;
  },
  removeLoginErrTipTime: () => {
    localStorage.removeItem('LOGIN_ERR_TIP_TIME');
  },
  saveUserInfo: userInfo => {
    localStorage.setItem(Constant.USERINFO, JSON.stringify(userInfo));
  },
  getUserInfo: () => {
    let val = localStorage.getItem(Constant.USERINFO);
    if (val) {
      return JSON.parse(val);
    }
    return null;
  },

  /**
   * MpUserInfo信息
   */
  saveMpUserInfo: mpUserInfo => {
    localStorage.setItem(Constant.MPUSERINFO, JSON.stringify(mpUserInfo));
  },
  getMpUserInfo: () => {
    let val = localStorage.getItem(Constant.MPUSERINFO);
    if (val) {
      return JSON.parse(val);
    }
    return null;
  },
  removeMpUserInfo: () => {
    localStorage.removeItem(Constant.MPUSERINFO);
  },

  //pathName
  savePathName: pathName => {
    if (pathName) {
      localStorage.setItem(Constant.PATHNAME, pathName);
    }
  },
  getPathName: () => {
    return localStorage.getItem(Constant.PATHNAME);
  },
  removePathName: () => {
    localStorage.removeItem(Constant.PATHNAME);
  },

  //LoginState
  saveLoginState: state => {
    localStorage.setItem(Constant.LOGINSTATE, state);
  },
  getLoginState: () => {
    return localStorage.getItem(Constant.LOGINSTATE);
  },
  removeLoginState: () => {
    localStorage.removeItem(Constant.LOGINSTATE);
  },

  //currentAgent
  saveCurrentAgent: currentAgent => {
    localStorage.setItem(Constant.CURRENTAGENT, JSON.stringify(currentAgent));
  },
  getCurrentAgent: () => {
    let val = localStorage.getItem(Constant.CURRENTAGENT);
    if (val) {
      return JSON.parse(val);
    }
    return null;
  },
  removeCurrentAgent: () => {
    localStorage.removeItem(Constant.CURRENTAGENT);
  },

  //CurrentLocation
  saveCurrentLocation: location => {
    localStorage.setItem(Constant.CURRENTLOCATION, JSON.stringify(location));
  },
  getCurrentLocation: () => {
    let val = localStorage.getItem(Constant.CURRENTLOCATION);
    if (val) {
      return JSON.parse(val);
    }
    return null;
  },
  removeCurrentLocation: () => {
    localStorage.removeItem(Constant.CURRENTLOCATION);
  },

  //ChooseLocation
  saveChooseLocation: location => {
    localStorage.setItem(Constant.CHOOSELOCATION, JSON.stringify(location));
  },
  getChooseLocation: () => {
    let val = localStorage.getItem(Constant.CHOOSELOCATION);
    if (val) {
      return JSON.parse(val);
    }
    return null;
  },
  removeChooseLocation: () => {
    localStorage.removeItem(Constant.CHOOSELOCATION);
  },
  /**
   * decorationEntrust
   * */

  saveSelectLocation(location) {
    localStorage.setItem(Constant.SELECTLOCATION, JSON.stringify(location));
  },
  getSelectLocation: () => {
    let val = localStorage.getItem(Constant.SELECTLOCATION);
    if (val) {
      return JSON.parse(val);
    }
    return null;
  },
  removeSelectLocation: () => {
    localStorage.removeItem(Constant.SELECTLOCATION);
  },
  /**
   * 保存自己发送的消息，需要排序去重
   */
  saveMsgBySessionGuid: (SessionGuid, msg) => {
    let msgs = localStorage.getItem(SessionGuid);
    if (msgs) {
      const parsedMsgs = JSON.parse(msgs);
      const updatedMsgs = CommonUtil.sortMsg(parsedMsgs, msg);
      localStorage.setItem(SessionGuid, JSON.stringify(updatedMsgs));
    } else {
      localStorage.setItem(SessionGuid, JSON.stringify([msg]));
    }
  },
  saveMsgBySpliceSessionGuid: (SessionGuid, msg) => {
    let msgs = localStorage.getItem(SessionGuid);
    if (msgs) {
      const parsedMsgs = JSON.parse(msgs);
      const updatedMsgs = CommonUtil.sortSpliceMsg(parsedMsgs, msg);
      localStorage.setItem(SessionGuid, JSON.stringify(updatedMsgs));
    } else {
      localStorage.setItem(SessionGuid, JSON.stringify([msg]));
    }
  },

  /**
   *
   * 保存收到的消息,直接替换之前的值
   *
   */
  saveReceiveMsgBySessionGuid: (SessionGuid, msgs) => {
    localStorage.setItem(SessionGuid, JSON.stringify(msgs));
  },

  // 获取会话消息
  getMsgBySessionGuid: SessionGuid => {
    let msgs = localStorage.getItem(SessionGuid);
    if (msgs) {
      return JSON.parse(msgs);
    }
    return null;
  },

  removeMsgBySessionGuid: SessionGuid => {
    localStorage.removeItem(SessionGuid);
  },

  //code
  saveCode: code => {
    localStorage.setItem(Constant.CODE, code);
  },
  getCode: () => {
    return localStorage.getItem(Constant.CODE);
  },
  removeCode: () => {
    localStorage.removeItem(Constant.CODE);
  },

  //猜你喜欢
  saveLikeData: data => {
    localStorage.setItem('LIKE_DATA', JSON.stringify(data));
  },
  getLikeData: () => {
    let data = localStorage.getItem('LIKE_DATA');
    if (data) {
      return JSON.parse(data);
    }
    return null;
  },
  removeLikeData: () => {
    localStorage.removeItem('LIKE_DATA');
  },


  //设置消息授权key
  saveSubscribeMessageKey: date => {
    localStorage.setItem('SUBSCRIBE_MESSAGE_KEY', date);
  },
  getSubscribeMessageKey: () => {
    return localStorage.getItem('SUBSCRIBE_MESSAGE_KEY');
  },
  removeSubscribeMessageKey: () => {
    localStorage.removeItem('SUBSCRIBE_MESSAGE_KEY');
  },
  //获取配置完成
  saveGetConfigEnd: date => {
    localStorage.setItem('GET_CONFIG_END', date);
  },
  getGetConfigEnd: () => {
    return localStorage.getItem('GET_CONFIG_END');
  },
  // 从 Realm 数据库查询历史消息
  queryHistoryFromRealm(targetGuid, fromGuid, lastMsgGuid, limit = 10) {
    return new Promise((resolve, reject) => {
      try {
        // 尝试多个可能的key
        const possibleKeys = [targetGuid, fromGuid, `history_${targetGuid}_${fromGuid}`];
        let allMessages = [];

        for (const key of possibleKeys) {
          const history = localStorage.getItem(key);
          if (history) {
            try {
              const messages = JSON.parse(history);
              if (Array.isArray(messages)) {
                allMessages = [...allMessages, ...messages];
              }
            } catch (e) {
              console.warn(`Parse history for key ${key} failed:`, e);
            }
          }
        }

        if (allMessages.length === 0) {
          resolve([]);
          return;
        }

        // 去重（按guid）
        const uniqueMessages = [];
        const guidSet = new Set();

        allMessages.forEach(msg => {
          if (msg && msg.guid && !guidSet.has(msg.guid)) {
            guidSet.add(msg.guid);
            uniqueMessages.push(msg);
          }
        });

        // 按时间排序
        const sortedMessages = uniqueMessages.sort((a, b) => (a.time || 0) - (b.time || 0));

        // 根据 lastMsgGuid 定位
        let startIndex = sortedMessages.length;
        if (lastMsgGuid) {
          const foundIndex = sortedMessages.findIndex(msg => msg.guid === lastMsgGuid);
          if (foundIndex !== -1) {
            startIndex = foundIndex;
          }
        }

        // 获取更早的消息
        const result = sortedMessages.slice(Math.max(0, startIndex - limit), startIndex);
        resolve(result);

      } catch (error) {
        console.error('Query history error:', error);
        reject(error);
      }
    });
  },
};
